import clsx from "clsx";
import FlagSvg from "@/images/flag-icon.svg?react";
import styles from "./FlagIcon.module.scss";

interface Props {
  width: number;
  height: number;
  rotate: number;
  className?: string;
}

export function FlagIcon(props: Props) {
  return (
    <FlagSvg
      width={props.width}
      height={props.height}
      role="img"
      aria-label="Flag"
      className={clsx(styles.flag, props.className)}
      style={{ transform: `rotate(${props.rotate}deg)` }}
    />
  );
}
